// extracted by mini-css-extract-plugin
module.exports = {"block":"InfoBlock_block__1EOcg","title":"InfoBlock_title__2BBub","content":"InfoBlock_content__1rqhF"};